<div class="colour-buttons-container">
    <ng-container *ngFor="let colour of colours">
        <div class="colour-button-container" (click)="changedValue({ral: colour.ral, hex: colour.hex})" [class.active]="currentColour === colour.ral" [attr.data-balloon]="colour.ral" data-balloon-pos="up">
            <div class="colour-button" [ngStyle]="{'background-color': colour.hex}">
                <i class="icon">check</i>
            </div>
        </div>
    </ng-container>
</div>
